import noImageCompany from '../../../../../../assets/images/emptyCompany.jpg';
import CardHeaders from '../../../../../layouts/Card/cardContent/CardHeaders';

export const listSettings = {
    grid : {
        components : CardHeaders,
        columns : {
            xs : 2,
            sm : 3,
            laptop : 3,
        }
    },
}

export const listMappers = [
    {
        view : 'card',
        mapper : null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card' : ['6'],
}